import { Game } from '../game/game.js'
import { Render } from './render.js'

import { 
    ACTION_ATTACK, ACTION_MOVE, ACTION_REST,
    DIRECTION_DOWN, DIRECTION_LEFT, DIRECTION_RIGHT, DIRECTION_UP  
} from '../game/constants.js'


const state = {
    action: null,
    direction: null,
    settings: {
        adversaries: 'random',
        partiers: 'random',
        map: 'random',
    },
    game: null,
}

class Interface {
    constructor() {
        // console.info("Interface.js - constructing")
        
        this.loadMaps()
        
        this.handleKey = this.handleKey.bind(this)
        window.addEventListener('keyup', this.handleKey)

        this.handleMouse = this.handleMouse.bind(this)
        window.addEventListener('mouseup', this.handleMouse)
        
        this.handleTouch = this.handleTouch.bind(this)
        window.addEventListener('touchend', this.handleTouch)

        Render.all(state)
    }


    decipherEvent(event) {
        if(state.game === null) {
            this.startGame()
            return
        }

        if(state.game.state.ended) {
            this.startGame()
            return
        }

        const cell = event.target
        if(cell.classList.contains('masked')) {
            return
        }

        let parsedId
        if(cell.classList.contains('terrain')) {
            parsedId = cell.id.split('-')
        } else if(cell.classList.contains('character')) {
            
            if(cell.parentElement.classList.contains('masked')) {
                return
            }
            
            if(cell.classList.contains('partier')) {
                state.game.state.action = ACTION_REST
                state.game.state.direction = null
                
                return
            } 
            
            parsedId = cell.parentElement.id.split('-')
        } else {
            console.error('clicked something that wasn\'t terrain or a character')
        }

        // do something
        const clickedPosition = {
            x: Number.parseInt(parsedId[0]),
            y: Number.parseInt(parsedId[1]),
        }

        const attack = state.game.state.map.actions.attack.find(attack => {
            return (
                attack.position.x === clickedPosition.x 
                    && 
                attack.position.y === clickedPosition.y
            )
        })

        if(attack) {
            state.game.state.action = ACTION_ATTACK
            state.game.state.direction = attack.direction
            
            return
        }

        const move = state.game.state.map.actions.move.find(move => {
            return (
                move.position.x === clickedPosition.x 
                    && 
                move.position.y === clickedPosition.y)
        })

        if(move) {
            state.game.state.action = ACTION_MOVE
            state.game.state.direction = move.direction
        }
    }

    endGame() {
        // console.info('Interface.js - ending game')

        const terrainCells = document.getElementsByClassName("terrain")

        while(terrainCells.length > 0) {
            terrainCells[0].remove()
        }
        
        clearInterval(this.intervalId)
        // console.log('if')
        // state.game.endGame()
        
        Render.all(state)
    }

    handleKey(event) {    
        event.preventDefault()

        // ignore shift, ctrl, alt, cmd (chrome, safari), cmd (firefox) 
        if([16, 17, 18, 91, 224].includes(event.keyCode)) return
        
        // I don't like it when the game starts when I tab away so I'm putting this
        // after the meta keys. we'll see if it stays here, it's just annoying for dev.
        if(state.game === null) {
            this.startGame()
            return
        }

        if(state.game.state.ended) {
            this.startGame()
            return
        }

        // handle keys
        switch(event.keyCode) {
            case 27:        // esc
                state.game.setAction(null)
                break
            case 37:        // left arrow
                state.game.setDirection(DIRECTION_LEFT)
                break
            case 38:        // up arrow
                state.game.setDirection(DIRECTION_UP)
                break
            case 39:        // right arrow
                state.game.setDirection(DIRECTION_RIGHT)
                break
            case 40:        // down arrow
                state.game.setDirection(DIRECTION_DOWN)
                break
            case 65:        // 'A'
            case 97:        // 'a'
                state.game.setDirection(null)
                state.game.setAction(ACTION_ATTACK)
                Render.all()

                break
            case 77:        // 'M'
            case 109:       // 'm'
                state.game.setDirection(null)
                state.game.setAction(ACTION_MOVE)
                Render.all()

                break

            case 81:        // 'Q'
            case 113:       // 'q'
                this.endGame()
                break

            case 32:        // space bar
            case 81:        // 'R'
            case 114:       // 'r'
            case 90:        // 'Z'
            case 122:       // 'z'
                state.game.setDirection(null)
                state.game.setAction(ACTION_REST)
                
                break
            default:
                console.error(`Unbound key: ${event.keyCode}`)
        }
    }

    handleMouse(event) {
        event.preventDefault()
        return this.decipherEvent(event)
    }

    handleTouch(event) {       
        event.preventDefault()
        return this.decipherEvent(event)
    }

    loadMaps() {
        Game.mapList().forEach(map => {
            const option = document.createElement('option')
            option.value = map.name
            option.innerText = map.name
            document.getElementById('content-pane-settings-map').appendChild(option)
        })
    }

    startGame() {
        state.settings = {
            adversaries: document.getElementById('content-pane-settings-adversaries').value,
            map: document.getElementById('content-pane-settings-map').value,
            partiers: document.getElementById('content-pane-settings-partiers').value,

        }

        state.game = new Game(state.settings)
        this.intervalId = setInterval(() => {this.tick()}, 250)
    }

    tick() {
        if(state.game.state.ended) {
            const h1 = document.getElementById('content-pane-outro-header')
            if(state.game.state.allPartiersAreDead()) {
                h1.innerText = 'Adversaries Win!'
            } else {
                h1.innerText = 'Partiers Win!'
            }

            this.endGame()
        }

        state.game.tick()

        Render.all(state)
    }
}

window.addEventListener("DOMContentLoaded", () => new Interface())